<script>
    import REST from '../utils/rest.js';
    let errors = {};
    let info = {
        name: "",
        email_id: "",
        phone_num: "",
        resort: "",
        callon: "",
        help: ""
    };
    let showModal = false, submitting = false;
    const onSubmit = async () => {
        errors = {};
        submitting = true;
        showModal = false;
        info.callstate = info.callon == 'At Earliest' ? '1' : info.callon == 'Business Hours' ? 2 : 3;
        let result = await REST.post("contact.php", info);
        submitting = false;
        if(result){
            if(result.errors){
                errors = result.errors;
            }else{
                showModal = true;
                info = {
                    name: "",
                    email_id: "",
                    phone_num: "",
                    resort: "",
                    callon: "",
                    help: ""
                };
            }
        }
    }
</script>

<svelte:head>
    {#if showModal}
        <style>
            body {
                overflow-y: hidden;
            }
        </style>
    {/if}
</svelte:head>

<div class="image-background">
	<h1 class="header_text_wrapper text-left"><span>Contact us</span><span class="separator"></span></h1>
</div>
<div class="page-content">
	<section class="container-fluid">
		<div  class="row gap-10">
			<div class="col-md-8 col-12">
                <div class="contact_form_cust">
                    <div class="vc_column-inner ">
                        <div class="wpb_wrapper">
                            <div class="wpb_raw_code wpb_content_element wpb_raw_html">
                                <div class="wpb_wrapper">
                                        <form action="" method="post" class="home_block_box_bg" on:submit|preventDefault={onSubmit}>
                                            <!-- {#if showModal}
                                                <div class="cont_form text-center">
                                                    <div class="row">
                                                        <div class="col-sm-12">
                                                            <p>Dear Sir / Madam ,Your details have been recorded successfully fff,
                                                                <br>we will get back to you as requested. Thank you.</p>
                                                        </div>
                                                    </div>
                                                </div>
                                            {/if} -->
                                            <fieldset class="contact_form_cust">
                                                <legend>
                                                    <h2>Your enquiry below</h2></legend>
                                                <div class="cont_form">
                                                    <div class="row">
                                                        <div class="col-sm-12">
                                                            <div class="form-group name">
                                                                <label for="" class="">Your Name <span class="required">*</span></label>
                                                                <input class="form-control" name="name" bind:value={info.name} aria-invalid="false" aria-required="true" required="" type="text">
                                                                {#if errors.name}
                                                                    <span class="error">* {errors.name}</span>
                                                                {/if}
                                                            </div> <span class="required_field"></span> </div>
                                                        <div class="col-sm-12">
                                                            <div class="form-group phone_num">
                                                                <label for="" class="">Phone Number <span class="required">*</span></label>
                                                                <input class="form-control" name="phone_num" bind:value={info.phone_num} aria-invalid="false" aria-required="true" required="" type="text">
                                                                {#if errors.phone_num}
                                                                    <span class="error">* {errors.phone_num}</span>
                                                                {/if}
                                                            </div> <span class="required_field"></span> </div>
                                                        <div class="col-sm-12">
                                                            <div class="form-group email_id">
                                                                <label for="" class="">Email ID <span class="required">*</span></label>
                                                                <input class="form-control" name="email_id" bind:value={info.email_id} aria-invalid="false" aria-required="true" required="" type="text">
                                                                {#if errors.email_id}
                                                                    <span class="error">* {errors.email_id}</span>
                                                                {/if}
                                                            </div> <span class="required_field"></span> </div>
                                                        <div class="col-sm-12">
                                                            <label for="" class="">Would you like to explore the Resort ? Pre Visit MangoMist for a tour, to plan your perfect Getaway.(Complimentary Drink/Snack Provided)<span class="required">*</span></label>
                                                            <div class="form-group wpcf7-form-control wpcf7-radio resort">
                                                                <div class="radio">
                                                                    <label for="">
                                                                        <input name="resort" value="Yes" checked="checked" aria-invalid="false" type="radio" bind:group={info.resort}>Yes</label>
                                                                </div>
                                                                <div class="radio">
                                                                    <label for="">
                                                                        <input name="resort" value="No" aria-invalid="false" type="radio">No</label>
                                                                </div>
                                                                {#if errors.resort}
                                                                    <span class="error">* {errors.resort}</span>
                                                                {/if}
                                                            </div>
                                                        </div>
                                                        <div class="col-sm-12">&nbsp;</div>
                                                        <div class="col-sm-12">
                                                            <label for="" class="">Call/Email<span class="required">*</span></label>
                                                            <div class="form-group wpcf7-form-control wpcf7-radio callstate">
                                                                <div class="radio">
                                                                    <label for="">
                                                                        <input name="callstate" value="At Earliest" checked="checked" aria-invalid="false" type="radio" bind:group={info.callon} >At Earliest</label>
                                                                </div>
                                                                <div class="radio">
                                                                    <label for="">
                                                                        <input name="callstate" value="Business Hours" aria-invalid="false" type="radio" bind:group={info.callon}>Business Hours</label>
                                                                </div>
                                                                <div class="radio">
                                                                    <label for="">
                                                                        <input name="callstate" value="Email only" aria-invalid="false" type="radio" bind:group={info.callon}>Email only</label>
                                                                </div>
                                                                {#if errors.callon}
                                                                    <span class="error">* {errors.callon}</span>
                                                                {/if}
                                                            </div>
                                                        </div>
                                                        <div class="col-sm-12">
                                                            <div class="form-group help">
                                                                <label for="" class="">How may we serve you <span class="required">*</span></label>
                                                                <textarea class="wpcf7-form-control wpcf7-textarea wpcf7-validates-as-required form-control" name="help" rows="4" aria-invalid="false" aria-required="true" required="" bind:value={info.help}/>
                                                            </div> <span class="required_field"></span> </div>
                                                            {#if errors.help}
                                                                <span class="error">* {errors.help}</span>
                                                            {/if}
                                                    </div>
                                                    <div class="row">
                                                        <div class="col-sm-6">
                                                            <div class="btn-primary-container">
                                                                <input class="wpcf7-form-control wpcf7-submit contact_submit btn btn-primary style-1 style-1" name="submit" value="Submit" type="submit" disabled={submitting}> </div>
                                                                {#if Object.keys(errors).length > 0}
                                                                    <span class="error">* Errors found while submitting the form</span>
                                                                {/if}
                                                        </div>
                                                    </div>
                                                </div>
                                            </fieldset>
                                            <div class="wpcf7-response-output wpcf7-display-none alert"></div>
                                           
                                        </form>
                                    
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
			</div>
			<div class="col-md-4 col-12">
                <div class="home_block_box_bg contact_form_cust contact_form_cust_right">
                    <div class="inner-gap-15">
                        <div class="wpb_wrapper">
                            <h2 class="calluna-heading calluna-heading-single-line text-align-left"><span>Info</span></h2>
                            <div class="vc_empty_space" style="height: 15px"><span class="vc_empty_space_inner"></span></div>
                            <div class="calluna-icon-box clr calluna-icon-box-one calluna-icon-box-with-link align-center">
                                <a href="#" title="ADDRESS" class="calluna-icon-box-one-link"> <img class="calluna-icon-box-one-img-alt" src="../images/contact_location-2.png" alt="ADDRESS" style="width:30px;">
                                    <h4 class="calluna-icon-box-one-heading pb-0 text-transform-capitalize" style="color:#0f2453;font-size:20px;letter-spacing:1px;">
                                        ADDRESS
                                    </h4>
                                </a>
                                <div class="calluna-icon-box-one-content clr">
                                    <p> Mango Mist Resorts
                                        <br> Sy No 33,37,Harapanahalli
                                        <br> Bannerghatta Road , near Jigani
                                        <br> Bengaluru
                                        <br> India <span id=":6dq.co" class="tL8wMe EMoHub" dir="ltr">560105</span>
                                    </p>
                                </div>
                            </div>
                            <div class="vc_empty_space" style="height: 15px"><span class="vc_empty_space_inner"></span></div>
                            <div class="calluna-icon-box clr calluna-icon-box-one align-center"> <img class="calluna-icon-box-one-img-alt" src="../images/contact_phone-2.png" alt="Phone" style="width:30px;">
                                <h4 class="calluna-icon-box-one-heading pb-0 text-transform-capitalize" style="color:#0f2453;font-size:20px;letter-spacing:1px;">
                                    Phone
                                </h4>
                                <div class="calluna-icon-box-one-content clr">
                                    <p><a href="tel:+919060090777">P. 9060090777</a></p>
                                </div>
                            </div>
                            <div class="vc_empty_space" style="height: 15px"><span class="vc_empty_space_inner"></span></div>
                            <div class="calluna-icon-box clr calluna-icon-box-one align-center"> <img class="calluna-icon-box-one-img-alt" src="../images/contact_mail-2.png" alt="MAIL " style="width:30px;">
                                <h4 class="calluna-icon-box-one-heading pb-0 text-transform-capitalize" style="color:#0f2453;font-size:20px;letter-spacing:1px;">
                                    MAIL 
                                </h4>
                                <div class="calluna-icon-box-one-content clr">
                                    <p>Mail: <span class="style105"><a href="mailto:resort@mangomist.com">resort@mangomist.com</a></span></p>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
			</div>
		</div>
		<div class="vc_row-full-width vc_clearfix"></div>
	</section>
	<div class="vc_row-full-width vc_clearfix"></div>
	<div class="vc_row wpb_row vc_row-fluid vc_row-no-padding" style="position: relative; left: -133.156px; box-sizing: border-box; width: 1852px;">
		<div class="column-style-1 vc_col-sm-12">
			<div class="vc_column-inner ">
				<div class="wpb_wrapper"></div>
			</div>
		</div>
	</div>
	<div class="vc_row-full-width vc_clearfix"></div>
	<div class="vc_row wpb_row vc_row-fluid" style="height:0">
		<div class="vc_col-sm-12"></div>
	</div>
</div>
{#if showModal}
    <div class="bg-patch-modal" on:click|preventDefault={()=>{showModal = false}}>
        <div class="modal-content">
            <!-- <div class="modal-header"> 
                <span>Success</span>
            </div> -->
            <button on:click|preventDefault={()=>{showModal = false}} class="close" aria-label="Close modal" style="">
                X
            </button>
            <div class="modal-body">
                <p>
                    Dear Sir / Madam ,Your details have been recorded successfully,
                    <br>we will get back to you as requested. Thank you.
                </p>
            </div>
        </div>
    </div>
{/if}
<style>

    .image-background {
        background: url("../images/Contact-1.jpg") no-repeat center;
    }
    /* The Modal (background) */
    
    .modal-content {
        position: relative;
        border-radius: 1em;
        background-color: #fefefe;
        margin: auto;
        padding: 0;
        border: 1px solid #888;
        width: 50%;
        box-shadow: 0 4px 8px 0 rgba(0, 0, 0, 0.2), 0 6px 20px 0 rgba(0, 0, 0, 0.19);
        -webkit-animation-name: animatetop;
        -webkit-animation-duration: 0.4s;
        animation-name: animatetop;
        animation-duration: 0.4s
    }

    .close {
        display: block;
        box-sizing: border-box;
        position: absolute;
        z-index: 1000;
        top: 1rem;
        right: 1rem;
        margin: 0;
        padding: 0;
        width: 1.5rem;
        height: 1.5rem;
        border: 0;
        color: black;
        border-radius: 1.5rem;
        background: white;
        box-shadow: 0 0 0 1px black;
        transition: transform 0.2s cubic-bezier(0.25, 0.1, 0.25, 1), background 0.2s cubic-bezier(0.25, 0.1, 0.25, 1);
        -webkit-appearance: none;
    }
    /* Add Animation */
    
    @-webkit-keyframes animatetop {
        from {
            top: -300px;
            opacity: 0
        }
        to {
            top: 0;
            opacity: 1
        }
    }
    
    @keyframes animatetop {
        from {
            top: -300px;
            opacity: 0
        }
        to {
            top: 0;
            opacity: 1
        }
    }
    
    .modal-header {
        padding: 2px 16px;
        background-color: #0F2453;
        color: white;
    }
    
    .modal-header span {
        font-size: 20px;
        text-align: center;
        color: #fff;
    }
    
    .modal-body {
        padding: 40px 24px;
        text-align: center;
    }

    .modal-body p {
        margin-bottom: 0;
    }

    .home_block_box_bg {
        padding-top: 45px;
        -moz-border-bottom-colors: none;
        -moz-border-left-colors: none;
        -moz-border-right-colors: none;
        -moz-border-top-colors: none;
        background: rgba(130, 130, 130, 0.3) none repeat scroll 0 0;
        border-color: rgba(255, 255, 255, 0.4) rgba(60, 60, 60, 0.4) rgba(60, 60, 60, 0.4) rgba(255, 255, 255, 0.4);
        border-image: none;
        border-radius: 25px;
        box-shadow: 8px 8px 8px #888888;
    }

    .page-content {
        background: rgba(0, 0, 0, 0) url(../images/gpattern-opacity-1.png) repeat scroll 0 0;
        padding-top: 35px;
    }

    .contact_form_cust {
        height: 100%;
    }

    .contact_form_cust_right {
        height: auto;
    }

    fieldset.contact_form_cust {
        padding-left: 45px;
        padding-right: 45px;
    }

    h2 {
        margin: 0;
        padding: 0;
    }

    h2:after {
        display: none;
    }

    .cont_form {
        padding-top: 30px;
    }

    .form-control {
        height: 48px;
        font-size: 1rem;
        color: #444;
        -webkit-box-shadow: none;
        -moz-box-shadow: none;
        box-shadow: none;
        border-radius: 0;
    }

    .calluna-icon-box-one {
        position: relative;
        padding-left: 50px;
    }

    .calluna-icon-box-one-img-alt {
        position: absolute;
        left: 0;
        top: 6px;
        display: block;
        color: #0f2453;
    }

    .calluna-icon-box-one .calluna-icon-box-one-heading {
        margin: 0 0 10px;
        font-size: 14px;
        color: #0f2453;
        font-size: 20px;
        letter-spacing: 1px;
    }

    .calluna-icon-box-one p {
        margin: 0 0 10px;
    }

    .calluna-icon-box-one p {
        font-size: 1.125rem;
        line-height: 2rem;
    }

    textarea.form-control {
        height: auto;
    }
    
    input[type="radio"] {
        margin-top: 10px;
    }

    .inner-gap-15 {
        padding-left: 15px;
        padding-right: 15px;
    }

    .radio label {
        min-height: 20px;
        display: flex;
        gap: 10px;
        margin-bottom: 0;
        font-weight: 400;
        cursor: pointer;
    }

    .error{
        font-size: 14px;
        color: red;
    }

    .bg-patch-modal {
        position: fixed;
        z-index: 1000;
        top: 0;
        left: 0;
        display: flex;
        flex-direction: column;
        justify-content: center;
        width: 100vw;
        height: 100vh;
        background: rgba(0, 0, 0, 0.66);
    }

    .pb-0 {
        padding-bottom: 0;
    }
</style>